<div class="sk-button-content d-flex flex-row justify-content-start align-items-center" [class.deactivated]="deactivated">
  <ng-content></ng-content>
</div>
